import React from 'react'
import Drawer from "react-drag-drawer";
import { playSong } from '../../utils/song'
import songsName from '../../enums/songsName'
import { FiX } from 'react-icons/fi';
import LogoPng from '../../assets/images/new/logo.webp'
import { BsArrowLeftCircle } from 'react-icons/bs';

const KnowMoreModal = (props) => {
  const closeHandler = () => {
    playSong(songsName.TAP)
    props.close()
  }

  return (
    <Drawer
      dontApplyListeners={true}
      allowClose={false}
      open={props.isOpened}
      onRequestClose={props.close}
      direction="left"
      containerElementClass="h-override"
      modalElementClass="h-override fixed top-0 left-0 z-10"
    >
      <div
        className='w-screen max-w-lg override bg-modal flex flex-col justify-start items-start px-4 text-lg overflow-y-auto'
        style={{
          paddingTop: window.native_app_status_bar_height ?? 16,
          paddingBottom: window.native_app_navigation_bar_height ?? 16
        }}
      >
        <div className='w-full flex flex-row justify-between items-center'>
          <div
            className='flex flex-row justify-start items-center cursor-pointer'
            onMouseEnter={() => {
              playSong(songsName.TAP)
            }}
            onClick={() => {
              playSong(songsName.TAP)

              props.backToDrawerMenu()
            }}
          >
            <BsArrowLeftCircle className="w-8 h-8 text-pallet-1" />
          </div>

          <img src={LogoPng} className='h-8 mx-auto' alt='Logo' />

          <button
            type="button"
            onMouseEnter={() => {
              playSong(songsName.TAP)
            }}
            onClick={closeHandler}
            className={`text-black bg-transparent hover:bg-slate-200 rounded-lg text-2xl lg:text-xl`}
          >
            <FiX className="w-8 h-8 text-pallet-1" />
          </button>
        </div>

        <h2 className='text-pallet-1 font-bold text-xl text-center mx-auto my-8'>Como funciona</h2>

        <div className='text-lg'>
          <p className='mb-2'>Descubra ou reencontre os autores que estão fazendo a literatura brasileira.</p>
          <p className='mb-2'>A Máquina de Contos é a plataforma dos contos brasileiros contemporâneos. Todos os meses, chega aos assinantes um novo volume digital, em áudio e texto, para acrescentar à biblioteca. Com uma primorosa curadoria, a Máquina de Contos apresenta a cada número um grande nome da literatura brasileira atual, em formato ideal para leitura em dispositivos ou para ouvir, com narração profissional. </p>
          <p className='mb-2'>Para fazer parte da Máquina de Contos você pode fazer uma assinatura ou entrar com uma empresa parceira. Além de receber os novos números todos os meses, você ganha uma biblioteca de contos de presente ao começar.</p>
          <p className='mb-2'>Leia seus contos on-line, baixe para ler sem estar conectado e guarde-os para sempre. Os livros são seus, permanecerão na sua biblioteca mesmo que você deixe de ser assinante ou cliente da empresa parceira. Basta fazer download.</p>
          <p className='mb-2'>Os autores e autoras que estão fazendo a nossa literatura estão aqui!</p>
          <p className='text-sm'>* Antes de assinar ou entrar, leia os Termos de Uso</p>
        </div>
      </div>
    </Drawer>
  )
}

export default KnowMoreModal